export const pricingTranslations = {
  en: {
    // Subscribe page (FLAT keys)
    subscribeBack: "← Back",
    subscribeBrandTitle: "Chase the Weather Pro",
    subscribeBrandSub: "Follow the weather",
    subscribeBrandAlt: "Chase the Weather",
    subscribeTitle: "Activate Pro access",
    subscribeLead: "You'll complete payment with Paddle.",
    subscribeBadgeSecure: "Secure checkout via Paddle",
    subscribeBadgeCancel: "Cancel anytime",
    subscribeBadgeInstant: "Pro activates instantly",
    subscribeEmailLabel: "Email",
    subscribeEmailPlaceholder: "name@domain.com",
    subscribeSectionTitle: "What you get with Pro",
    subscribeFeatureUnlockedTitle: "Full Route Planner access",
    subscribeFeatureUnlockedDesc: "Full access to Pro features in the app.",
    subscribeFeatureOverviewTitle: "Better overview & scoring",
    subscribeFeatureOverviewDesc: "Clearer guidance for weather-based decisions.",
    subscribeFeatureAccuracyTitle: "More accuracy & calculations",
    subscribeFeatureAccuracyDesc: "Extra calculations where it matters.",
    subscribeFeatureSupportTitle: "Supports ongoing development",
    subscribeFeatureSupportDesc: "Your purchase helps us keep improving Chase the Weather.",
    subscribeOopsTitle: "Oops!",
    subscribeMissingCheckoutUrl: "Missing checkout URL.",
    subscribeSomethingWentWrong: "Something went wrong.",
    subscribeCtaMain: "Continue to checkout",
    subscribeCtaBusy: "Opening checkout…",
    subscribeCtaSub: "You can cancel later.",
    subscribeFinePrint: "Payment is handled via Paddle.",
    subscribeSecondary: "Back",
    subscribeFooter: "Questions? Email us.",

    // Success page (FLAT keys)
    successBack: "Back to Chase the Weather",
    successBackToHome: "Back to home",
    successTitle: "Payment received",
    successChecking: "Verifying your Pro access…",
    successSubtitleActive: "Your Chase the Weather Pro access is now active.",
    successSubtitlePending: "Payment received. Pro usually activates instantly — give it a moment.",
    successFine: "Try refreshing shortly.",
    successBadgeSecure: "Secure payment via Paddle",
    successBadgeInstant: "Pro activates instantly",
    successBadgeCancel: "Cancel anytime",
    successStatusChecking: "Checking…",
    successStatusActive: "Pro active",
    successStatusActivating: "Activating",
    successPillTitle: "Chase the Weather Pro",
    successPillSub: "Follow the weather",
    successBrandAlt: "Chase the Weather",
    successFinePrint:
      "If Pro access doesn't activate immediately, it will be enabled automatically within a few minutes.",
    successSupportLine:
      "If anything doesn't work as expected, contact us and we'll assist you promptly.",

    // Pricing page
    pricingBack: "← Back",
    pricingBrandTitle: "Chase the Weather Pro",
    pricingBrandSub: "Follow the weather",

    pricingTitle: "Choose your plan",
    pricingLead:
      "Chase the Weather Pro helps you decide where to go, when to move, and why — based on real conditions nearby.",
    pricingNotLoggedIn: "We'll ask for your email before checkout.",

    pricingYearlyTitle: "Yearly",
    pricingBestValue: "Best value",
    pricingPerYear: "per year",
    pricingYearlyMicro: "Billed once a year · Cancel anytime",

    pricingMonthlyTitle: "Monthly",
    pricingPerMonth: "per month",

    pricingFeatureAllPro: "Full Route Planner access — know when it's worth moving",
    pricingFeatureWindShelter: "Wind direction & shelter score — see why one site is calmer",
    pricingFeatureComparisons: "Unlimited comparisons across all 242 campsites in Iceland",
    pricingFeatureCancelAnytime: "Cancel anytime",
    // Ticket 416 (#416) — same short bullet on all four plan feature arrays.
    // Ticket #431: no longer referenced as a plan-benefit bullet (Pricing.jsx)
    // — kept defined in case another consumer needs the plain feature name.
    pricingFeatureAurora: "Northern Lights: details and place comparison",
    pricingAuroraLearnMoreLink: "Learn more about Northern Lights",

    pricingCtaYearly: "Start annual subscription",
    pricingCtaMonthly: "Start monthly subscription",
    pricingYearlyEquivalentMonthly: "≈ €2 per month",
    pricingYearlySavings: "Save about €40 per year",

    pricingFinePrint: "You can manage or cancel anytime in the billing portal.",

    pricingYearlyRenewalText: "Renews automatically every year until cancelled. You can cancel at any time and keep access until the end of the paid period.",
    pricingMonthlyRenewalText: "Renews automatically every month until cancelled. You can cancel at any time and keep access until the end of the paid period.",
    pricingCtaConfirm: "By continuing, you agree that your subscription will renew automatically according to the selected billing period until cancelled.",

    pricingAlreadyYearly: "Your yearly subscription is already active.",
    pricingActiveUntil: "Active until",
    pricingYearlyActive: "Subscription active",
    pricingMonthlyActive: "Monthly subscription active",
    pricingMonthlyUpgradeHint:
      "You can upgrade to yearly at any time. Monthly cannot be purchased twice.",
    pricingCtaUpgradeToYearly: "Upgrade to Yearly",
    pricingMonthlyAlreadyActive: "Monthly is active",
    pricingMonthlyNotAvailable: "Not available",
    subscribeAlreadyActive: "Your subscription is already active.",
    subscribeAlreadyMonthly: "You already have an active monthly subscription.",

    pricingChargedInEur: "Payment is processed in euros (€) at checkout.",

    pricingInfoBack: "← Back to forecast",
    pricingInfoEyebrow: "Chase the Weather Pro",
    pricingInfoTitle: "How Pro turns weather data into a clear decision",
    pricingInfoLead:
      "Full rankings, side-by-side comparisons, and guidance on whether it's worth moving — across all 242 campsites, so you're not guessing where, when, or why.",

    pricingInfoFeature1Title: "Wind direction & shelter",
    pricingInfoFeature1Body: "See wind direction and a shelter score to pick calmer, more sheltered campsites.",
    pricingInfoFeature2Title: "Route Planner",
    pricingInfoFeature2Body: "Find nearby campsites where the weather may be better.",
    pricingInfoFeature3Title: "Full Top 5 ranking",
    pricingInfoFeature3Body: "See every top-ranked campsite in Iceland right now, not just a preview — so you know where your best options actually are.",
    pricingInfoFeature4Title: "Compare two campsites",
    pricingInfoFeature4Body:
      "See day by day which campsite is calmer, drier or warmer, and open an hourly breakdown when the decision matters.",

    // Ticket 416 (#416) — compact Free/Pro Northern Lights explanation.
    // auroraInfo* (same-assessment, seasonal note) are shared keys, see
    // translations.northernLights.js.
    // Ticket #431: Free and Pro now get identical Northern Lights detail —
    // both bodies describe the same thing; the title no longer claims Pro
    // has more.
    pricingInfoAuroraTitle: "Northern Lights: same assessment and detail for everyone",
    pricingInfoAuroraFreeLabel: "Free",
    pricingInfoAuroraFreeBody:
      "The named best location, reasons and expanded comparison — plus a list of qualifying places and a map when results support them.",
    pricingInfoAuroraProLabel: "Pro",
    pricingInfoAuroraProBody:
      "The named best location, reasons and expanded comparison — plus a list of qualifying places and a map when results support them.",

    pricingInfoMonthlyLabel: "Monthly",
    pricingInfoMonthlyPrice: "/ month",
    pricingInfoMonthlyBody: "Flexible access to Chase the Weather Pro features.",
    pricingInfoYearlyLabel: "Yearly",
    pricingInfoYearlyPrice: "/ year",
    pricingInfoYearlyBody: "Best value if you use Chase the Weather regularly.",

    pricingInfoPass30Label: "30-Day Travel Pass",
    pricingInfoPass30Body: "One-time purchase. Pro access for 30 days from purchase date. No auto-renewal.",
    pricingInfoPassYearLabel: "Annual Pass",
    pricingInfoPassYearBody: "One-time purchase. Pro access for 1 year (365 days) from purchase date. No auto-renewal.",
    pricingInfoOneTime: "one-time",

    pricingInfoTrustTitle: "Good to know",
    pricingInfoTrustBody:
      "Chase the Weather offers a 14-day refund period from the initial purchase of a new subscription or pass. Subscriptions can be managed through the billing portal. Passes expire automatically after their access period — no cancellation needed.",
    pricingInfoRefundLink: "Refund policy",
    pricingInfoUpgradeLink: "Get Chase the Weather Pro",
  },
  is: {
    // Subscribe page (FLAT keys)
    subscribeBack: "← Til baka",
    subscribeBrandTitle: "Eltum Veðrið Pro",
    subscribeBrandSub: "Eltum veðrið",
    subscribeBrandAlt: "Eltum Veðrið",
    subscribeTitle: "Virkja Pro aðgang",
    subscribeLead: "Þú greiðir í gegnum Paddle.",
    subscribeBadgeSecure: "Örugg greiðsla í gegnum Paddle",
    subscribeBadgeCancel: "Hætta hvenær sem er",
    subscribeBadgeInstant: "Pro virkjast strax",
    subscribeEmailLabel: "Netfang",
    subscribeEmailPlaceholder: "nafn@domain.is",
    subscribeSectionTitle: "Hvað fylgir Pro",
    subscribeFeatureUnlockedTitle: "Allir Pro fídusar opnast",
    subscribeFeatureUnlockedDesc: "Fullur aðgangur að Pro í appinu.",
    subscribeFeatureOverviewTitle: "Betri yfirsýn & stig",
    subscribeFeatureOverviewDesc: "Skýrari leiðsögn fyrir veðurtengdar ákvarðanir.",
    subscribeFeatureAccuracyTitle: "Meiri nákvæmni & útreikningar",
    subscribeFeatureAccuracyDesc: "Aukaútreikningar þar sem það skiptir máli.",
    subscribeFeatureSupportTitle: "Styður áframhaldandi þróun",
    subscribeFeatureSupportDesc: "Kaupin hjálpa okkur að bæta Eltum Veðrið áfram.",
    subscribeOopsTitle: "Úbbs!",
    subscribeMissingCheckoutUrl: "Vantar checkout URL.",
    subscribeSomethingWentWrong: "Eitthvað fór úrskeiðis.",
    subscribeCtaMain: "Halda áfram í greiðslu",
    subscribeCtaBusy: "Opna greiðslu…",
    subscribeCtaSub: "Þú getur hætt seinna.",
    subscribeFinePrint: "Greiðsla fer fram í gegnum Paddle.",
    subscribeSecondary: "Til baka",
    subscribeFooter: "Spurningar? Sendu okkur línu.",

    // Success page (FLAT keys)
    successBack: "Fara í Eltum Veðrið",
    successBackToHome: "Til baka heim",
    successTitle: "Greiðsla móttekin",
    successChecking: "Staðfesti Pro aðgang…",
    successSubtitleActive: "Eltum Veðrið Pro aðgangur hefur verið virkjaður.",
    successSubtitlePending:
      "Greiðsla móttekin. Pro virkjast yfirleitt strax — gefðu þessu smá stund.",
    successFine: "Prófaðu að endurhlaða eftir smá stund.",
    successBadgeSecure: "Örugg greiðsla í gegnum Paddle",
    successBadgeInstant: "Pro virkjast strax",
    successBadgeCancel: "Hætta hvenær sem er",
    successStatusChecking: "Athuga…",
    successStatusActive: "Pro virkt",
    successStatusActivating: "Virkjar",
    successPillTitle: "Eltum Veðrið Pro",
    successPillSub: "Eltum veðrið",
    successBrandAlt: "Eltum Veðrið",
    successFinePrint:
      "Ef Pro aðgangur virkjast ekki strax, uppfærist hann sjálfkrafa innan örfárra mínútna.",
    successSupportLine:
      "Ef eitthvað virkar ekki sem skyldi, hafðu samband og við aðstoðum þig fljótt.",

    // Pricing page (Íslenska)
    pricingBack: "← Til baka",
    pricingBrandTitle: "Eltum Veðrið Pro",
    pricingBrandSub: "Fylgstu með veðrinu",

    pricingTitle: "Veldu leiðina að Pro",
    pricingLead:
      "Eltum Veðrið Pro hjálpar þér að ákveða hvert þú átt að fara, hvenær og hvers vegna — út frá raunverulegum aðstæðum í nágrenninu.",
    pricingNotLoggedIn: "Við biðjum um netfang áður en þú ferð í greiðslu.",

    pricingYearlyTitle: "Ársáskrift",
    pricingPerYear: "á ári",
    pricingYearlyMicro: "Rukkað einu sinni á ári · Hægt að segja upp hvenær sem er",

    pricingMonthlyTitle: "Mánaðaráskrift",
    pricingPerMonth: "á mánuði",

    pricingFeatureAllPro: "Fullur aðgangur að Ferðaráðgjafa — veistu hvenær borgar sig að færa sig",
    pricingFeatureWindShelter: "Vindátt og skjólstuðull — sjáðu af hverju einn staður er rólegri",
    pricingFeatureComparisons: "Ótakmarkaður samanburður á öllum 242 tjaldsvæðum landsins",
    pricingFeatureCancelAnytime: "Hægt að segja upp hvenær sem er",
    pricingFeatureAurora: "Norðurljós: nánari upplýsingar og samanburður staða",
    pricingAuroraLearnMoreLink: "Sjá nánar um norðurljós",

    pricingCtaYearly: "Hefja ársáskrift",
    pricingCtaMonthly: "Hefja mánaðaráskrift",
    pricingYearlyEquivalentMonthly: "≈ 290 kr á mánuði",
    pricingYearlySavings: "Sparar um 5.890 kr á ári miðað við mánaðarverð",

    pricingFinePrint: "Þú getur stjórnað eða sagt upp hvenær sem er í greiðslugáttinni.",

    pricingYearlyRenewalText: "Endurnýjast sjálfkrafa árlega þar til áskriftinni er sagt upp. Þú getur sagt henni upp hvenær sem er og heldur aðgangi út greitt áskriftartímabil.",
    pricingMonthlyRenewalText: "Endurnýjast sjálfkrafa mánaðarlega þar til áskriftinni er sagt upp. Þú getur sagt henni upp hvenær sem er og heldur aðgangi út greitt áskriftartímabil.",
    pricingCtaConfirm: "Með því að halda áfram samþykkir þú að áskriftin endurnýist sjálfkrafa samkvæmt valinni greiðslutíðni þar til henni er sagt upp.",

    pricingAlreadyYearly: "Ársáskriftin þín er nú þegar virk.",
    pricingActiveUntil: "Virkt til",
    pricingYearlyActive: "Áskrift virk",
    pricingMonthlyActive: "Mánaðaráskrift virk",
    pricingMonthlyUpgradeHint:
      "Þú getur uppfært í ársáskrift hvenær sem er. Ekki er hægt að kaupa mánaðaráskrift tvisvar.",
    pricingCtaUpgradeToYearly: "Uppfæra í ársáskrift",
    pricingMonthlyAlreadyActive: "Mánaðaráskrift virk",
    pricingMonthlyNotAvailable: "Ekki í boði",
    subscribeAlreadyActive: "Áskriftin þín er nú þegar virk.",
    subscribeAlreadyMonthly: "Þú ert nú þegar með virka mánaðaráskrift.",

    pricingChargedInEur: "Upphæð er rukkuð í evrum (€). Krónuverð er eingöngu til viðmiðunar.",
    pricingBestValue: "Mest virði",

    pricingInfoBack: "← Til baka í spá",
    pricingInfoEyebrow: "Eltum Veðrið Pro",
    pricingInfoTitle: "Svona hjálpar Pro þér að taka ákvörðun",
    pricingInfoLead:
      "Fullur listi, samanburður hlið við hlið og leiðsögn um hvort borgi sig að færa sig — fyrir öll 242 tjaldsvæði landsins — svo þú þarft ekki að giska á hvert, hvenær eða hvers vegna.",

    pricingInfoFeature1Title: "Vindátt og skjól",
    pricingInfoFeature1Body: "Sjáðu vindátt og skjólstuðul til að velja rólegri, skjólsælli tjaldsvæði.",
    pricingInfoFeature2Title: "Ferðaráðgjafi",
    pricingInfoFeature2Body: "Finndu staði í nágrenninu þar sem veðrið gæti verið betra.",
    pricingInfoFeature3Title: "Fullur Topp 5-listi",
    pricingInfoFeature3Body: "Sjáðu öll efstu tjaldsvæðin á landinu núna, ekki bara sýnishorn — svo þú vitir hvar bestu kostirnir raunverulega eru.",
    pricingInfoFeature4Title: "Berðu saman tvö tjaldsvæði",
    pricingInfoFeature4Body:
      "Sjáðu dag frá degi hvort tjaldsvæðið er rólegra, þurrara eða hlýrra og opnaðu klukkutímasamanburð þegar ákvörðunin skiptir máli.",

    pricingInfoAuroraTitle: "Norðurljós: sama mat og sömu smáatriði fyrir alla",
    pricingInfoAuroraFreeLabel: "Free",
    pricingInfoAuroraFreeBody:
      "Nafngreindur besti staðurinn, ástæður og ítarlegri samanburður — auk lista yfir hæfa staði og korts þegar niðurstöður leyfa.",
    pricingInfoAuroraProLabel: "Pro",
    pricingInfoAuroraProBody:
      "Nafngreindur besti staðurinn, ástæður og ítarlegri samanburður — auk lista yfir hæfa staði og korts þegar niðurstöður leyfa.",

    pricingInfoMonthlyLabel: "Mánaðaráskrift",
    pricingInfoMonthlyPrice: "/ mánuður",
    pricingInfoMonthlyBody: "Sveigjanlegur aðgangur að Eltum Veðrið Pro eiginleikum.",
    pricingInfoYearlyLabel: "Ársáskrift",
    pricingInfoYearlyPrice: "/ ár",
    pricingInfoYearlyBody: "Besti kosturinn ef þú notar Eltum Veðrið reglulega.",

    pricingInfoPass30Label: "30 daga ferðapassi",
    pricingInfoPass30Body: "Eingreiðsla. Pro aðgangur í 30 daga frá kaupdegi. Engin sjálfvirk endurnýjun.",
    pricingInfoPassYearLabel: "Árspassi",
    pricingInfoPassYearBody: "Eingreiðsla. Pro aðgangur í 1 ár (365 dagar) frá kaupdegi. Engin sjálfvirk endurnýjun.",
    pricingInfoOneTime: "eingreiðsla",

    pricingInfoTrustTitle: "Gott að vita",
    pricingInfoTrustBody:
      "Eltum Veðrið býður upp á 14 daga endurgreiðslufrest frá fyrstu greiðslu nýrrar áskriftar eða passa. Áskriftum er stjórnað í gegnum greiðslugáttina. Passar renna sjálfkrafa út að loknum aðgangstíma — engin uppsögn þarf.",
    pricingInfoRefundLink: "Sjá endurgreiðslustefnu",
    pricingInfoUpgradeLink: "Fá Eltum Veðrið Pro",
  },
};
